<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'appointmentType', params: {} }">
            Appointment Type
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'appointmentTypeView', params: {} }">
              View Appointment Type
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Appointment Type
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="appointmentType.label">
            <td max-width="35%" class="text-subtitle-1">Label:</td>
            <td>{{ appointmentType.label }}</td>
          </tr>
          
          <tr v-if="appointmentType.description">
            <td max-width="35%" class="text-subtitle-1">Description:</td>
            <td>{{ appointmentType.description }}</td>
          </tr>
          
          <tr v-if="appointmentType.color">
            <td max-width="35%" class="text-subtitle-1">Color:</td>
            <td>{{ appointmentType.color }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getAppointmentType } from "@/services/appointmentType";
    

    export default {
      data() {
        return {
            id: '',
            appointmentType: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "appointmentTypeEdit", params: { id: id }});
        },
        setInstace() {
          this.setDependencies().then( () => {
            getAppointmentType(this.id)
            .then((response) => {
              this.appointmentType = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading appointmentType");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstace();
        this.$emit("showParent", false);
      }
    }
    </script>
    